<portal-sub-nav [force]="force" route="enterprise-settings">
  <portal-menu-context [heading]="'menu.settings' | portalTranslate"></portal-menu-context>

  <!-- Customer settings -->
  <portal-sub-nav-item route="enterprise-settings-customer">
    <ng-template portalTransclude>
      <span>{{ 'menu.settings.enterprise' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Sites -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.EDIT_SITE, Permission.MANAGE_SITES],
    }"
    route="enterprise-sites"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.settings.site' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Screen Numbers -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.MANAGE_SCREEN_NUMBER, Permission.VIEW_SCREEN_NUMBER],
    }"
    route="enterprise-screen-numbers"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.screenNumbers' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Announcements -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ANNOUNCEMENTS, Permission.MANAGE_ANNOUNCEMENTS],
    }"
    route="enterprise-announcements"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.announcements' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Enterprise Options -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ENTERPRISE_OPTIONS],
    }"
    route="enterprise-options"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.enterpriseOptions' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Administrators -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ADMINS],
    }"
    route="enterprise-administrator"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.admins' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Rooms -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ROOMS],
    }"
    route="enterprise-rooms"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.settings.rooms' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Routing Groups -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ROUTING_GROUP, Permission.MANAGE_ROUTING_GROUP],
    }"
    route="enterprise-routing-groups"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.routingGroups' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Call Barring -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ENTERPRISE_ACL, Permission.VIEW_ANY_ENTERPRISE_ACL],
    }"
    route="enterprise-call-barring"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.callBarring' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Ip Filter -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_IPFILTER],
    }"
    route="enterprise-ipfilter"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.ipFilter' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Time Table -->
  <portal-sub-nav-item
    *portalIsAuthorized="{ anyPermission: [Permission.VIEW_TIMETABLES] }"
    route="enterprise-time-table"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.timeTable' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Holiday Lists -->
  <portal-sub-nav-item
    *portalIsAuthorized="{ anyPermission: [Permission.VIEW_TIMETABLES] }"
    route="enterprise-holiday-lists"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.holidayLists' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Presence information -->
  <portal-sub-nav-item
    *portalHasEnterpriseOption="EnterpriseOption.RichPresenceService"
    route="enterprise-presence-information"
  >
    <span *portalTransclude>{{ 'menu.presence' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Teams presence sync -->
  <portal-sub-nav-item
    *portalHasEnterpriseOption="EnterpriseOption.Microsoft365PresenceSyncFeatures"
    route="enterprise-ms365-presence"
  >
    <span *portalTransclude>{{ 'menu.ms365Presence' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Device attribute settings  -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_DEVICE_SETTINGS, Permission.MANAGE_DEVICE_SETTINGS],
    }"
    route="enterprise-device-attributes"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.deviceAttributeSettings' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>
</portal-sub-nav>
